import { render } from "./FallbackSmartButton.vue?vue&type=template&id=426837d5&lang=pug"
import script from "./FallbackSmartButton.vue?vue&type=script&lang=js"
export * from "./FallbackSmartButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__